<style lang="scss">
@import '../css/sub.scss';
</style>
<template>
  <div class="donga-audit">
    <audit-header></audit-header>
    <div class="audit-template sub-template">
      <div role="sub" class="audit-sub">
        <div id="sub-sections">
          <div class="visual-top report-complete">
            <h2 class="page-tit">제보완료</h2>
            <p class="page-sub-tit pc-show">감사실과 제보자간의 쌍방향 소통방식으로 운영되며 동아쏘시오 그룹사 임직원 뿐만 아니라<br>고객, 협력회사 등 모든 이해관계자 여러분의 소중한 의견을 자유롭게 제안할 수 있는 곳으로 그룹사와 이해관계자<br>모두의 발전에 도움이 되도록 적극적인 참여 바랍니다.</p>
          </div>
          <div class="col-container">
            <div class="sub-contents">
              <section class="sub-section complete-section">
                  <h3 class="complete-tit">제보 접수가 완료되었습니다.</h3>
                  <div class="output-area select-password">
                    <p class="complete-txt">귀하의 접수전호는 <span class="default-color">{{ receiptNumber }}</span>이며,<br>이 번호는 작성하신 제보의 처리결과 확인시 필요합니다.<br>결과를 확인하기 위해서는 <span class="underline">접수번호와 비밀번호</span>가 필요합니다.</p>
                    <p class="complete-notice">처리결과 확인을 위해서는 비밀번호와 내용작성 완료 후 발급되는 접수번호가 필요하오니 기록해두시길 바랍니다.<br>(개인정보를 수집하는 관계로 접수번호를 잊어버리신 경우 해당접수건의 확인이 불가합니다. 반드시 숙지하여 주시기 바랍니다.)</p>
                  </div>
                  <div class="report-complete-btns">
                      <router-link to="/" class="default-btn confirm" >확인</router-link>
                      <router-link to="/reportinquiry" class="default-btn report-confirm">제보내용 확인</router-link>
                  </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <audit-footer></audit-footer>
  </div>
</template>
<script>
import AuditHeader from '@/components/AuditHeader'
import AuditFooter from '@/components/AuditFooter'
import { mapGetters } from 'vuex'
export default {
  name: 'ReportComplete',
  components: {
    'audit-header': AuditHeader,
    'audit-footer': AuditFooter
  },
  computed: {
    ...mapGetters({
      receiptNumber: 'getReceiptNumber'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ReportComplete.vue